import React from 'react'
import Joyride, { STATUS } from 'react-joyride'
import * as CustomStyles from '../styles/CustomStyles'
import { connect } from 'react-redux'
import { submitWalkthrough } from '../../../store/ui/actions'
import { getHasWalkthrough } from '../../../store/login/reducers'
import { fetchHasWalkthrough } from '../../../store/login/actions'
import Translation from '../../global/Translation'
import { ReactComponent as IconTruck } from '../../../assets/img/icons/icon-catalog-shipping-truck.svg'
import { ReactComponent as IconWarning } from '../../../assets/img/icons/icon-catalog-warning.svg'
import { getWalkthroughWatched } from '../../../store/ui/reducers'

const mapStateToProps = (state, ownProps) => {
    return {
        hasWalkthrough: getHasWalkthrough(state),
        isWalkthroughWatched: getWalkthroughWatched(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSubmitWalkthrough: (type, noShowMore) => dispatch(submitWalkthrough(type, noShowMore)),
        refreshData: () => dispatch(fetchHasWalkthrough()),
        onWatchedWalkthrough: () => dispatch({ type: 'WALTHROUGH_HAS_BEEN_WATCHED' }),
        triggerWalkthroughInteraction: (step, fromOption) => {
            dispatch({
                type: 'APPLY_WALKTHROUGH_INTERACTION',
                payload: {
                    step,
                    fromOption
                }
            })
        }

    }
}

class NaturalStoneInAnotherCenterWalkthrough extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            type: this.props.walkthroughType,
            clickedDoNotShowAgain: false
        }
    }

    WALKTHROUGH_TYPE_SPAN = 'OUTLET_PN_FROM_OTHER_CENTERS'
    WALKTHROUGH_TYPE_BRAZIL = 'NATURAL_STONE_BRAZIL_IN_ANOTHER_CENTER'

    naturalStoneSpainContent = () => {
        return (
            <div className="walkthrough__tooltip__content">
                <div className="walkthrough__tooltip__content--heading">
                    <h2>
                        <Translation
                            id="walkthrough_buy_directly_from_cosentino_global_by_clicking_on_this_button"
                            defaultMessage="Buy directly from Cosentino Global by clicking on this button."
                        />
                    </h2>
                </div>
                <div className="walkthrough__tooltip__content--info">
                    <span>
                        <div className="walkthrough__tooltip__content__pn-outlet">
                            <div className="beggining">
                                <span>
                                    <Translation id="walkthrough_keep_in_mind_that" defaultMessage="Keep in mind that" />:
                                </span>
                            </div>
                            <div className="walkthrough__tooltip__content__pn-outlet--body">
                                <div className="first-block">
                                    <div>
                                        <IconTruck />
                                    </div>
                                    <div>
                                        <span>
                                            <Translation
                                                id="walkthrough_these_products_are_in_our_cosentino_global_delivery_may_be_longer"
                                                defaultMessage="These products are in our Cosentino Global Center. Delivery times may be longer than the delivery times of your usual Center."
                                            />
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="second-block">
                                    <div>
                                        <IconWarning />
                                    </div>
                                    <div>
                                        <span>
                                            <Translation id="walkthrough_limitations_on_natural_stone_products" defaultMessage="Limitations on Natural Stone products" />:
                                        </span>
                                        <ul>
                                            <li>
                                                <Translation
                                                    id="the_total_width_of_all_the_natural_stone_slabs_you_buy_from_HQ"
                                                    defaultMessage="The TOTAL thickness of all natural stone slabs purchased from the Spanish center must be at least: 12 cm. Example: 4 slabs of 3 cm = 12 cm."
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        )
    }

    naturalStoneBrazilContent = () => {
        return (
            <div className="walkthrough__tooltip__content">
                <div className="walkthrough__tooltip__content--heading">
                    <h2><Translation id="walkthrough_buy_directly_from_cosentino_brazil_by_clicking_on_this_button" defaultMessage="Buy directly from Cosentino Brazil by clicking on this button." /></h2>
                </div>
                <div className="walkthrough__tooltip__content--info">
                    <span>
                        <div className="walkthrough__tooltip__content__pn-outlet">
                            <div className="beggining">
                                <span>
                                    <Translation id="walkthrough_keep_in_mind_that" defaultMessage="Keep in mind that" />:
                                </span>
                            </div>
                            <div className="walkthrough__tooltip__content__pn-outlet--body">
                                <div className="first-block">
                                    <div>
                                        <IconTruck />
                                    </div>
                                    <div>
                                        <span>
                                            <Translation
                                                id="walkthrough_these_products_are_in_our_cosentino_brazil_delivery_may_be_longer"
                                                defaultMessage="These products are in our Cosentino Brazil Center. Delivery times may be longer than the delivery times of your usual Center."
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className="second-block">
                                    <div>
                                        <IconWarning />
                                    </div>
                                    <div>
                                        <span>
                                            <Translation id="the_purchase_is_only_allowed_per_bundle" defaultMessage="The purchase is only allowed per bundle." />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        )
    }

    steps = {
        mixNaturalStoneSteps: [
            {
                content: this.naturalStoneSpainContent(),
                locale: {
                    next: (
                        <span aria-label="next">
                            <Translation id="next" defaultMessage="Next" />
                        </span>
                    )
                },
                placement: 'auto',
                disableBeacon: true,
                target: '#natural_stone_spain_button'
            },
            {
                content: this.naturalStoneBrazilContent(),
                locale: {
                    back: (
                        <span aria-label="back">
                            <Translation id="back" defaultMessage="Back" />
                        </span>
                    ),
                    last: (
                        <span
                            aria-label="close"
                            onClick={() => this.handleNoShowMoreOnClick([this.WALKTHROUGH_TYPE_SPAN, this.WALKTHROUGH_TYPE_BRAZIL])}
                            style={{ fontSize: '14px' }}
                        >
                            <Translation id="do_not_show_again" defaultMessage="Do not show again" />
                        </span>
                    )
                },
                placement: 'auto',
                disableBeacon: true,
                target: '#natural_stone_brazil_button'
            }
        ],
        onlyNaturalStoneSpainStep: [
            {
                content: this.naturalStoneSpainContent(),
                locale: {
                    last: (
                        <span aria-label="close" onClick={() => this.handleNoShowMoreOnClick(this.WALKTHROUGH_TYPE_SPAN)} style={{ fontSize: '14px' }}>
                            <Translation id="do_not_show_again" defaultMessage="Do not show again" />
                        </span>
                    )
                },
                placement: 'auto',
                disableBeacon: true,
                target: '#natural_stone_spain_button'
            }
        ],
        onlyNaturalStoneBrazilStep: [
            {
                content: this.naturalStoneBrazilContent(),
                locale: {
                    last: (
                        <span aria-label="close" onClick={() => this.handleNoShowMoreOnClick(this.WALKTHROUGH_TYPE_BRAZIL)} style={{ fontSize: '14px' }}>
                            <Translation id="do_not_show_again" defaultMessage="Do not show again" />
                        </span>
                    )
                },
                placement: 'auto',
                disableBeacon: true,
                target: '#natural_stone_brazil_button'
            }
        ]
    }

    /**
     * Handle on click to submit the walkthrough data
     */
    handleNoShowMoreOnClick = type => {
        this.setState({ clickedDoNotShowAgain: true })
        return this.props.onSubmitWalkthrough(type, true).then(() => this.props.refreshData())
    }

    /**
     * Callback function to manipulate the walkthrough logic
     */
    handleJoyrideCallback = data => {
        const { status, index, action, type } = data
        const steps = this.getStepsByNaturalStoneViewingPermissions()
        const isLastStep = index === steps.length - 1

        if (type !== 'step:after') return
    
        let finalAction = action

        if (isLastStep && action === 'next' && this.state.clickedDoNotShowAgain) {
            finalAction = 'not-show-again'
        }
    
        const validActions = ['next', 'prev', 'close', 'not-show-again']

        if (validActions.includes(finalAction) && typeof index === 'number') {
            this.props.triggerWalkthroughInteraction(index, finalAction)
        }
    
        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            this.props.onWatchedWalkthrough()
        }
    }

    getStepsByNaturalStoneViewingPermissions = () => {
        const { mixNaturalStoneSteps, onlyNaturalStoneSpainStep, onlyNaturalStoneBrazilStep } = this.steps
        const { canViewHQ, canViewBrazil } = this.props.naturalStoneViewingPermissions

        const shouldShowSpainWalkthrough = canViewHQ && this.shouldShowWalkthrough(this.getWalkthroughByType(this.WALKTHROUGH_TYPE_SPAN))
        const shouldShowBrazilWalkthrough  = canViewBrazil && this.shouldShowWalkthrough(this.getWalkthroughByType(this.WALKTHROUGH_TYPE_BRAZIL))

        if (shouldShowSpainWalkthrough && !shouldShowBrazilWalkthrough) {
            return onlyNaturalStoneSpainStep
        } else if (shouldShowBrazilWalkthrough && !shouldShowSpainWalkthrough) {
            return onlyNaturalStoneBrazilStep
        } else if (shouldShowSpainWalkthrough || shouldShowBrazilWalkthrough) {
            return mixNaturalStoneSteps
        } else {
            return []
        }
    }

    getWalkthroughByType = walkthroughType => {
        const { hasWalkthrough } = this.props

        if (hasWalkthrough && hasWalkthrough.length > 0) {
            return hasWalkthrough.find(walkthrough => walkthrough.type === walkthroughType)
        }

        return null
    }

    shouldShowWalkthrough = walkthrough => {
        return walkthrough && walkthrough.shouldShow
    }

    render() {
        const { isWalkthroughWatched } = this.props

        return (this.shouldShowWalkthrough(this.getWalkthroughByType(this.WALKTHROUGH_TYPE_SPAN)) ||
            this.shouldShowWalkthrough(this.getWalkthroughByType(this.WALKTHROUGH_TYPE_BRAZIL))) &&
            !isWalkthroughWatched ? (
            <React.Fragment>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous
                    steps={this.getStepsByNaturalStoneViewingPermissions()}
                    styles={{
                        tooltip: CustomStyles.TooltipStyles,
                        tooltipContent: CustomStyles.TooltipContentStyles,
                        options: CustomStyles.OptionStyles,
                        buttonBack: CustomStyles.ButtonBackStyles,
                        tooltipFooter: CustomStyles.TooltipFooterStyles,
                        spotlight: CustomStyles.SpotlightSyles
                    }}
                    disableScrolling
                />
            </React.Fragment>
        ) : null
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NaturalStoneInAnotherCenterWalkthrough)
